
import React, { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { MenuItem, LinearProgress } from '@mui/material'
import AWVApi from '../../../assets/constants/AWVRafservice.Instance';
import api from '../../../assets/constants/Rafservice.Instance';
import { signOut, currentRoute, currentLOBSelect, currentProjectGroupSelect, currentProviderGroupSelect, currentYearSelect } from '../../../store/actions';
import history from '../../../history';
import {
    SELECT_YEAR, SELECT_LOB,
    SELECT_PROVIDER_GROUP, PROVIDER_GROUP_LIST, yearLimit, SELECT_PROJECT, PROJECT_GROUP_LIST
} from "../../../assets/constants/string.constants";
import Select, { components } from "react-select";

const HeaderFilter = (props) => {
    const [selectYear, setSelectYear] = useState();
    const [selectLob, setSelectLob] = useState();
    const [selectProject, setSelectProject] = useState(6);
    const [selectProviderGroup, setSelectProviderGroup] = useState([]);
    const [providerGroupList, setProviderGroupList] = useState([]);
    const [providerGroupOnlyList, setProviderGroupOnlyList] = useState([]);
    const [projectLists, setProjectLists] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [selectProjectGroup, setSelectProjectGroup] = useState([]);
    const [projectsOnlyList, setProjectsOnlyList] = useState([]);
    const [projectMenuOpen, setProjectMenuOpen] = useState(false);
    const [providerMenuOpen, setProviderMenuOpen] = useState(false);

    const projectRef = useRef(null);
    const providerRef = useRef(null);
    const lobList = [
        { 'value': 1, 'label': 'ACA' },
        { 'value': 2, 'label': 'Medicare' },
        { 'value': 3, 'label': 'Medicaid' }
    ];
    const projectList = [
        { 'value': 6, 'label': 'ACA-ChartChase' }
    ];

    useEffect(() => {
        const fetchData = async () => {
            await getYearList();
            await getProviderGroup();
            await oldSelectedData();
            await getProjects();
        };

        fetchData();
    }, []);

    const oldSelectedData = () => {
        if (localStorage.getItem(SELECT_YEAR) && localStorage.getItem(SELECT_YEAR) != '') {
            setSelectYear(localStorage.getItem(SELECT_YEAR));
            props.currentYearSelect(localStorage.getItem(SELECT_YEAR));
        } else {
            if (props?.selectedYear && props?.selectedYear != '') {
                localStorage.setItem(SELECT_YEAR, props?.selectedYear);
                setSelectYear(props?.selectedYear);
                props.currentYearSelect(props?.selectedYear);
            } else {
                localStorage.setItem(SELECT_YEAR, new Date().getFullYear());
                setSelectYear(new Date().getFullYear());
                props.currentYearSelect(new Date().getFullYear());
            }
        }

        if (localStorage.getItem(SELECT_LOB) && localStorage.getItem(SELECT_LOB) != '') {
            setSelectLob(localStorage.getItem(SELECT_LOB));
            props.currentLOBSelect(localStorage.getItem(SELECT_LOB));
        } else {
            localStorage.setItem(SELECT_LOB, 2);
            setSelectLob(2);
            props.currentLOBSelect(2);
        }

        const storedProviderGroup = localStorage.getItem(SELECT_PROVIDER_GROUP);
if (storedProviderGroup && storedProviderGroup !== '') {
    setSelectProviderGroup(storedProviderGroup.startsWith("[") ? JSON.parse(storedProviderGroup) : [storedProviderGroup]);
    props.currentProviderGroupSelect(storedProviderGroup.startsWith("[") ? JSON.parse(storedProviderGroup) : [storedProviderGroup]);
} else {
    localStorage.setItem(SELECT_PROVIDER_GROUP, JSON.stringify(["ALL"]));
    setSelectProviderGroup(["ALL"]);
    props.currentProviderGroupSelect(["ALL"]);
}

const storedProjectGroup = localStorage.getItem(SELECT_PROJECT);
if (storedProjectGroup && storedProjectGroup !== '') {
    setSelectProjectGroup(storedProjectGroup.startsWith("[") ? JSON.parse(storedProjectGroup) : [storedProjectGroup]);
    props.currentProjectGroupSelect(storedProjectGroup.startsWith("[") ? JSON.parse(storedProjectGroup) : [storedProjectGroup]);
} else {
    localStorage.setItem(SELECT_PROJECT, JSON.stringify(["ALL"]));
    setSelectProjectGroup(["ALL"]);
    props.currentProjectGroupSelect(["ALL"]);
}

    }

    const getProjects = () => {
        AWVApi.get('/get_project_details')
            .then(res => {
                if (res.data) {
                    setProjectsOnlyList(res?.data);
                    const ProjectGroupOptions = [
                        { value: 'ALL', label: "ALL" },
                        ...res?.data.map(groupName => ({
                            value: groupName,
                            label: groupName.toString()
                        }))
                    ];
                    setProjectLists(ProjectGroupOptions);
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const getProviderGroup = () => {
        AWVApi.get('/getprovidergroup')
            .then(res => {
                if (res.data) {
                    setProviderGroupOnlyList(res?.data);
                    const ProviderGroupOptions = [
                        { value: 'ALL', label: "ALL" },
                        ...res?.data.map(groupName => ({
                            value: groupName,
                            label: groupName.toString()
                        }))
                    ];
                    setProviderGroupList(ProviderGroupOptions);
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const getYearList = () => {
        api.get('/yearList')
            .then(res => {
                if (res) {
                    const resArray = res.slice(0, yearLimit + 1);
                    const yearsOptions = resArray.map((year) => ({
                        value: year,
                        label: year.toString(),
                    }));
                    setYearList(yearsOptions);
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        localStorage.setItem(PROVIDER_GROUP_LIST, JSON.stringify(providerGroupOnlyList))
    }, [providerGroupOnlyList])

    useEffect(() => {
        localStorage.setItem(PROJECT_GROUP_LIST, JSON.stringify(projectsOnlyList))
    }, [projectsOnlyList])

    const handleLOBSelect = (e) => {
        localStorage.setItem(SELECT_LOB, e.value);
        setSelectLob(e.value);
    }

    const handleProjectGroupSelect = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        localStorage.setItem(SELECT_PROJECT, JSON.stringify(selectedValues));
        setSelectProjectGroup(selectedValues);
    };

    const handleProviderGroupSelect = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        localStorage.setItem(SELECT_PROVIDER_GROUP, JSON.stringify(selectedValues));
        setSelectProviderGroup(selectedValues);
    };

    const handleYearSelect = (e) => {
        localStorage.setItem(SELECT_YEAR, e.value);
        setSelectYear(e.value);
    }

    const handleApplyFilter = () => {
        props.currentLOBSelect(selectLob)
        props.currentProjectGroupSelect(selectProjectGroup);
        props.currentProviderGroupSelect(selectProviderGroup);
        props.currentYearSelect(selectYear);
    };

    const CustomValueContainerProject = ({ children, getValue, ...props }) => {
        const parsedProjectGroup = Array.isArray(selectProjectGroup) 
        ? selectProjectGroup 
        : JSON.parse(selectProjectGroup || "[]");
    
    const count = getValue().length > 0 ? getValue().length : parsedProjectGroup.length;
        return (
            <components.ValueContainer {...props}>
                {count > 0 ? `Project (${count})` : children}
            </components.ValueContainer>
        );
    };

    const CustomValueContainerProvider = ({ children, getValue, ...props }) => {
        const parsedProvidertGroup = Array.isArray(selectProviderGroup) 
        ? selectProviderGroup 
        : JSON.parse(selectProviderGroup || "[]");
    
    const count = getValue().length > 0 ? getValue().length : parsedProvidertGroup.length;
    
        return (
            <components.ValueContainer {...props}>
                {count > 0 ? `Provider Group (${count})` : children}
            </components.ValueContainer>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (projectRef.current && !projectRef.current.contains(event.target)) {
                setProjectMenuOpen(false);
            }
            if (providerRef.current && !providerRef.current.contains(event.target)) {
                setProviderMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={"card_header flex_item_cb flex-wrap mb24 " + props.className}>
            <h2 className="fs18 card-title">{props.title}</h2>
            <div className="right_part">
            <div className="flex_item_cc justify-content-start flex-wrap">
            <div ref={projectRef}>
                <Select
                    className="custom_select minw85 flex-grow-1"
                    classNamePrefix="custom_select"
                    placeholder="Project"
                    closeMenuOnSelect={false}
                    isSearchable={true}
                    isMulti={true}
                    options={projectLists}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    hideSelectedOptions={false}
                    backspaceRemovesValue={true}
                    menuPlacement="bottom"
                    /* value={projectLists.filter(option =>
                        selectProjectGroup.includes(option.value)
                    )} */
                    value={projectLists.filter(option => {
                       
                        // Ensure selectProviderGroup is always an array
                        const parsedProjectrGroup = Array.isArray(selectProjectGroup) 
                            ? selectProjectGroup 
                            : JSON.parse(selectProjectGroup || "[]");
                    
                        return parsedProjectrGroup.includes(option.value);
                    })}
                    onChange={(selectedOptions) => 
                        handleProjectGroupSelect(selectedOptions)
                    }
                    components={{ ValueContainer: CustomValueContainerProject }}
                    menuIsOpen={projectMenuOpen} 
                    onMenuOpen={() => setProjectMenuOpen(true)} 
                    onMenuClose={() => setProjectMenuOpen(false)}
                    styles={{
                        multiValue: (base) => ({
                            ...base,
                            display: 'none',
                        }),
                        container: (base) => ({
                            ...base,
                            width: '130px',
                            minWidth: '130px',
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            width: '100%',
                            paddingLeft: '10px',
                        }),
                        input: (base) => ({
                            ...base,
                            minWidth: '100px',
                        }),
                    }}
                />
            </div>

            {/* Provider Group Dropdown */}
            {!props?.providerGroup || props?.providerGroup !== 'hide' ? (
                <div ref={providerRef} className="custom_select_wrapper">
                    <Select
                                className="custom_select minw85 flex-grow-1"
                                classNamePrefix="custom_select"
                                placeholder="Provider Group"
                                closeMenuOnSelect={false}
                                isSearchable={true}
                                isMulti={true}
                                options={providerGroupList}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                hideSelectedOptions={false}
                                backspaceRemovesValue={true}
                                menuPlacement="bottom"
                                value={providerGroupList.filter(option => {
                                   
                                    // Ensure selectProviderGroup is always an array
                                    const parsedProviderGroup = Array.isArray(selectProviderGroup) 
                                        ? selectProviderGroup 
                                        : JSON.parse(selectProviderGroup || "[]");
                                
                                    return parsedProviderGroup.includes(option.value);
                                })}
                                
                                onChange={(selectedOptions) => {
                                    handleProviderGroupSelect(selectedOptions);
                                }}
                                menuIsOpen={providerMenuOpen}
                                onMenuOpen={() => setProviderMenuOpen(true)}
                                onMenuClose={() => setProviderMenuOpen(false)}
                                components={{ ValueContainer: CustomValueContainerProvider }}
                                styles={{
                                    multiValue: (base) => ({
                                        ...base,
                                        display: 'none',
                                    }),
                                    container: (base) => ({
                                        ...base,
                                        width: '200px',
                                        minWidth: '200px',
                                        position: 'relative',
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        width: '100%',
                                        paddingLeft: '10px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        minWidth: '100px',
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        cursor: 'pointer',
                                    }),
                                }}
                            />
                </div>
                    ) : null}

                    {props.pageName === 'ChartChasePage' ? (
                        <div className="flex_item_cs flex-wrap flex-sm-nowrap gap10">
                            <Select
                                className="custom_select minw100 flex-grow-1"
                                classNamePrefix="custom_select"
                                placeholder="Project"
                                closeMenuOnSelect={true}
                                options={projectList}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                hideSelectedOptions={true}
                                backspaceRemovesValue={false}
                                menuPlacement="bottom"
                                value={projectList.filter(({ value }) => value === selectProject)}
                            />
                        </div>
                    ) : (
                        <div className="flex_item_cs flex-wrap flex-sm-nowrap gap10">
                            <Select
                                className="custom_select minw100 flex-grow-1"
                                classNamePrefix="custom_select"
                                placeholder="LOB"
                                closeMenuOnSelect={true}
                                options={lobList}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.value}
                                hideSelectedOptions={true}
                                backspaceRemovesValue={false}
                                menuPlacement="bottom"
                                value={lobList.filter(({ value }) => value === Number(selectLob))}
                                onChange={handleLOBSelect}
                            />
                        </div>
                    )}

                    <div className="flex_item_cs flex-wrap flex-sm-nowrap gap10">
                        <Select
                            className="custom_select minw100 flex-grow-1"
                            classNamePrefix="custom_select"
                            placeholder="Year"
                            closeMenuOnSelect={true}
                            options={yearList}
                            getOptionLabel={option => option.label}
                            getOptionValue={option => option.value}
                            hideSelectedOptions={true}
                            backspaceRemovesValue={false}
                            menuPlacement="bottom"
                            value={yearList.filter(({ value }) => value === selectYear)}
                            onChange={handleYearSelect}
                        />
                    </div>
                    <div
                        className="flex_item_cs flex-wrap flex-sm-nowrap gap10 apply_button"
                        onClick={handleApplyFilter}
                        style={{ cursor: 'pointer' }}
                    >
                        <button
                            className="apply_button"
                            style={{ color: 'white' }}
                            onClick={(e) => {
                                e.stopPropagation(); // Prevents double firing when clicking the button
                                handleApplyFilter();
                            }}
                        >
                            Apply
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    isSignedIn: state.auth.isSignedIn,
    userName: state.auth?.userDetails?.userEmail,
    route: state.route.route,
    moduleSelect: state.moduleFilter.moduleSelect,
});

export default connect(mapStateToProps, {
    currentLOBSelect,
    currentProviderGroupSelect,
    currentYearSelect,
    currentProjectGroupSelect
})(HeaderFilter);